export const BOOK_TEMPLATE_TYPES = {
    FULL_PAGE: 'full-text',

    IMAGE_TOP_ONE_HALF: 'one-half-image-top',
    IMAGE_BOTTOM_ONE_HALF: 'one-half-image',

    IMAGE_TOP_ONE_THIRD: 'one-third-image-top',
    IMAGE_BOTTOM_ONE_THIRD: 'one-third-image',

    IMAGE_TOP_TWO_THIRDS: 'two-thirds-image-top',
    IMAGE_BOTTOM_TWO_THIRDS: 'two-thirds-image',
};

export const TRC_ARROW_BUTTON_DIRECTIONS = {
    LEFT: 'left',
    RIGHT: 'right',
};

export const TRO_PASSING_LEVEL_STATUSES = {
    PASS: 'Pass',
    NO_PASS: 'No Pass',
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    PENDING_RESPONSE: 'Pending Response',
    NOT_FOUND: 'Not Found',
};

export const TRC_BOOK_EMPTY_PAGE_TEXT = 'End of Book';

export const TRO_SUPPORTED_GRADES = {
    FIRST: '01',
    SECOND: '02',
    THIRD: '03',
    FOURTH: '04',
    FIFTH: '05',
    SIXTH: '06',
};

export const FORMATTED_GRADES = {
    '01': '1st Grade',
    '02': '2nd Grade',
    '03': '3rd Grade',
    '04': '4th Grade',
    '05': '5th Grade',
};

export const TRO_BOOK_CATEGORIES = {
    STARTING_BOOK: 'starting_book',
    LOW_BOOK: 'low_book',
    HIGH_BOOK: 'high_book',
};

export const TRO_BOOK_RELATIVE_LEVEL = {
    [TRO_BOOK_CATEGORIES.STARTING_BOOK]: 'benchmark',
    [TRO_BOOK_CATEGORIES.LOW_BOOK]: 'low',
    [TRO_BOOK_CATEGORIES.HIGH_BOOK]: 'high',
};

export const BOOK_ID = 'book_id';

export const TRO_BOOK_PREFIX_AND_SUFFIX_TYPES = {
    PAGE_START: 'page_start',
    PARAGRAPH_START: 'paragraph_start',
    PARAGRAPH_END: 'paragraph_end',
    BREAK: 'break',
    STRESS_START: 'stress_start',
    STRESS_END: 'stress_end',
    TITLE: 'title',
    TEXT: 'text',
};

export const TRO_CONTENT_CDN = 'https://lantern-tro-multimedia.aws.wgen.net';

export default BOOK_TEMPLATE_TYPES;
